import { render } from "./ExamTimer.vue?vue&type=template&id=3a716db6&scoped=true"
import script from "./ExamTimer.vue?vue&type=script&lang=js"
export * from "./ExamTimer.vue?vue&type=script&lang=js"

import "./ExamTimer.vue?vue&type=style&index=0&id=3a716db6&scoped=true&lang=css"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a716db6"]])

export default __exports__